export const TEMPLATE_ID_PROP = 'mgnl:template';

export default { TEMPLATE_ID_PROP };
